import React, { useEffect, useState } from "react";
import {
  FaPlay,
  FaSyncAlt,
  FaCheckCircle,
  FaTimesCircle,
} from "react-icons/fa";
import { axiosMaster, axiosSalary } from "../../api/axiosInstance";

const GenerateManualMonthlySummary = () => {
  let storedUser = {};

  try {
    storedUser = JSON.parse(localStorage.getItem("user") || "{}");
  } catch {
    storedUser = {};
  }

  const groupId = storedUser?.groupId;
  const userId = storedUser?.userId;

  const currentDate = new Date();

  const [restaurants, setRestaurants] = useState([]);
  const [employees, setEmployees] = useState([]);

  const [selectedRestId, setSelectedRestId] = useState("");
  const [selectedEmpId, setSelectedEmpId] = useState("");

  const [month, setMonth] = useState(currentDate.getMonth() + 1);
  const [year, setYear] = useState(currentDate.getFullYear());

  const [remarks, setRemarks] = useState("Manual Monthly Summary");

  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);

  const fetchRestaurants = async () => {
    try {
      const res = await axiosMaster.get(
        `/RestaurantMaster/GetByGroup?groupId=${groupId}`
      );

      const rows = res.data || [];

      setRestaurants(rows);

      if (rows.length > 0) {
        setSelectedRestId(rows[0].restId);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const fetchEmployees = async () => {
    try {
      const res = await axiosMaster.get(
        `/EmployeeMaster/GetByGroup?groupId=${groupId}`
      );

      const rows = res.data || [];

      const filtered = rows.filter(
        (x) => Number(x.restId) === Number(selectedRestId)
      );

      setEmployees(filtered);

      if (filtered.length > 0) {
        setSelectedEmpId(filtered[0].empId);
      } else {
        setSelectedEmpId("");
      }
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchRestaurants();
  }, []);

  useEffect(() => {
    if (selectedRestId) {
      fetchEmployees();
    }
  }, [selectedRestId]);

  useEffect(() => {
    setResult(null);
  }, [selectedEmpId, selectedRestId, month, year]);

  const generateSummary = async () => {
    if (!selectedEmpId) {
      alert("Please select employee");
      return;
    }

    try {
      setLoading(true);
      setResult(null);

      const payload = {
        groupId: Number(groupId),
        restId: Number(selectedRestId),
        empId: Number(selectedEmpId),
        month: Number(month),
        year: Number(year),
        userId: Number(userId),
        remarks: remarks || "Manual Monthly Summary",
      };

      const res = await axiosSalary.post(
        "/MonthlyAttendanceSummary/GenerateManualMonthlySummary",
        payload
      );

      setResult(res.data);
    } catch (err) {
      console.error(err);

      alert(
        err?.response?.data?.message ||
          "Error generating manual monthly summary"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-white rounded-2xl shadow-sm border border-slate-200 min-h-[calc(100vh-120px)]">
      <div className="px-6 py-5 border-b">
        <h2 className="text-xl font-bold text-slate-800">
          Generate Manual Monthly Summary
        </h2>

        <p className="text-sm text-slate-500 mt-1">
          Generate monthly summary employee wise.
        </p>
      </div>

      <div className="px-6 py-5 border-b">
        <div className="grid grid-cols-1 md:grid-cols-6 gap-3">
          {/* Restaurant */}
          <div>
            <label className="text-xs font-medium text-slate-500">
              Restaurant
            </label>

            <select
              value={selectedRestId}
              onChange={(e) => setSelectedRestId(e.target.value)}
              className="w-full mt-1 border rounded-lg px-3 py-2"
            >
              {restaurants.map((r) => (
                <option key={r.restId} value={r.restId}>
                  {r.restaurantName}
                </option>
              ))}
            </select>
          </div>

          {/* Employee */}
          <div>
            <label className="text-xs font-medium text-slate-500">
              Employee
            </label>

            <select
              value={selectedEmpId}
              onChange={(e) => setSelectedEmpId(e.target.value)}
              className="w-full mt-1 border rounded-lg px-3 py-2"
            >
              {employees.map((emp) => (
                <option key={emp.empId} value={emp.empId}>
                  {emp.empName}
                </option>
              ))}
            </select>
          </div>

          {/* Month */}
          <div>
            <label className="text-xs font-medium text-slate-500">
              Month
            </label>

            <select
              value={month}
              onChange={(e) => setMonth(Number(e.target.value))}
              className="w-full mt-1 border rounded-lg px-3 py-2"
            >
              {Array.from({ length: 12 }, (_, i) => (
                <option key={i + 1} value={i + 1}>
                  {new Date(2025, i, 1).toLocaleString("default", {
                    month: "long",
                  })}
                </option>
              ))}
            </select>
          </div>

          {/* Year */}
          <div>
            <label className="text-xs font-medium text-slate-500">
              Year
            </label>

            <select
              value={year}
              onChange={(e) => setYear(Number(e.target.value))}
              className="w-full mt-1 border rounded-lg px-3 py-2"
            >
              {[2025, 2026, 2027, 2028].map((y) => (
                <option key={y} value={y}>
                  {y}
                </option>
              ))}
            </select>
          </div>

          {/* Remarks */}
          <div>
            <label className="text-xs font-medium text-slate-500">
              Remarks
            </label>

            <input
              value={remarks}
              onChange={(e) => setRemarks(e.target.value)}
              className="w-full mt-1 border rounded-lg px-3 py-2"
            />
          </div>

          {/* Button */}
          <div className="flex items-end">
            <button
              onClick={generateSummary}
              disabled={loading}
              className="w-full bg-blue-600 hover:bg-blue-700 text-white rounded-lg px-4 py-2"
            >
              {loading ? (
                <>
                  <FaSyncAlt className="inline animate-spin mr-2" />
                  Processing...
                </>
              ) : (
                <>
                  <FaPlay className="inline mr-2" />
                  Generate
                </>
              )}
            </button>
          </div>
        </div>
      </div>

      <div className="p-6">
        {result && (
          <div className="max-w-3xl mx-auto">
            <div
              className={`rounded-2xl border p-6 shadow-sm ${
                result.success
                  ? "border-emerald-200 bg-emerald-50"
                  : "border-red-200 bg-red-50"
              }`}
            >
              <div className="flex items-center gap-3 mb-6">
                {result.success ? (
                  <FaCheckCircle className="text-3xl text-emerald-600" />
                ) : (
                  <FaTimesCircle className="text-3xl text-red-600" />
                )}

                <div>
                  <h3 className="text-lg font-bold text-slate-800">
                    Monthly Summary Result
                  </h3>

                  <p className="text-sm text-slate-500">
                    Employee wise monthly summary generation status
                  </p>
                </div>
              </div>

              <div className="grid md:grid-cols-2 gap-4">
                <div className="bg-white rounded-lg p-4 border">
                  <p className="text-xs text-slate-500">Employee ID</p>
                  <p className="font-semibold text-slate-800">
                    {result.empId}
                  </p>
                </div>

                <div className="bg-white rounded-lg p-4 border">
                  <p className="text-xs text-slate-500">Employee Name</p>
                  <p className="font-semibold text-slate-800">
                    {result.empName}
                  </p>
                </div>

                <div className="bg-white rounded-lg p-4 border">
                  <p className="text-xs text-slate-500">Status</p>

                  <p
                    className={`font-semibold ${
                      result.success ? "text-emerald-600" : "text-red-600"
                    }`}
                  >
                    {result.success ? "Success" : "Failed"}
                  </p>
                </div>

                <div className="bg-white rounded-lg p-4 border">
                  <p className="text-xs text-slate-500">Skipped</p>
                  <p className="font-semibold text-slate-800">
                    {result.isSkipped ? "Yes" : "No"}
                  </p>
                </div>
              </div>

              <div className="mt-4 bg-white rounded-lg p-4 border">
                <p className="text-xs text-slate-500 mb-1">Message</p>

                <p
                  className={`font-medium ${
                    result.success ? "text-emerald-700" : "text-red-700"
                  }`}
                >
                  {result.message}
                </p>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default GenerateManualMonthlySummary;